export default __webpack_public_path__ + "static/media/cover-erp.e6b5d5a9.png";